function getFileNameFromDisposition(disposition, fallbackName) {
  if (!disposition) return fallbackName;

  const encodedMatch = disposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (encodedMatch && encodedMatch[1]) {
    return normalizeFileName(
      decodeURIComponent(encodedMatch[1].replace(/"/g, '')),
      fallbackName,
    );
  }

  const match = disposition.match(/filename="?([^"]+)"?/i);
  return normalizeFileName(match && match[1] ? match[1] : fallbackName, fallbackName);
}

function normalizeFileName(fileName, fallbackName) {
  const normalizedName = String(fileName || '').trim();

  if (
    !normalizedName ||
    /(^|[_\-\s])(undefined|null)([_\-\s.]|$)/i.test(normalizedName)
  ) {
    return fallbackName;
  }

  return normalizedName;
}

function isMobileDevice() {
  if (typeof navigator === 'undefined') return false;

  const userAgent = navigator.userAgent || '';
  const platform = navigator.platform || '';

  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)
    || (platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

function normalizePdfBlob(data) {
  if (data instanceof Blob) {
    return data.type === 'application/pdf'
      ? data
      : data.slice(0, data.size, 'application/pdf');
  }

  return new Blob([data], { type: 'application/pdf' });
}

function downloadWithTemporaryLink(blob, fileName) {
  const blobUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = blobUrl;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();

  window.URL.revokeObjectURL(blobUrl);
}

export async function downloadPdfResponse(result, fallbackName, shareTitle) {
  const disposition = result.headers && result.headers['content-disposition'];
  const fileName = getFileNameFromDisposition(disposition, fallbackName);
  const blob = normalizePdfBlob(result.data);

  await downloadPdfBlob(blob, fileName, shareTitle);
}

export async function downloadPdfBlob(blobData, fileName, shareTitle) {
  const blob = normalizePdfBlob(blobData);

  if (isMobileDevice() && navigator.share && typeof File !== 'undefined') {
    const file = new File([blob], fileName, { type: 'application/pdf' });
    const payload = {
      files: [file],
      title: shareTitle || fileName,
    };

    if (!navigator.canShare || navigator.canShare(payload)) {
      try {
        await navigator.share(payload);
        return;
      } catch (error) {
        if (error && error.name === 'AbortError') return;
      }
    }
  }

  downloadWithTemporaryLink(blob, fileName);
}

export async function downloadPdfUrl(url, fileName, shareTitle) {
  if (isMobileDevice() && navigator.share && typeof File !== 'undefined') {
    try {
      const response = await fetch(url);
      const blob = await response.blob();

      await downloadPdfBlob(blob, fileName, shareTitle);
      return;
    } catch (error) {
      // Fall back to the regular browser download/open behavior below.
    }
  }

  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
}

// Requisições com responseType 'blob' recebem o corpo do erro como Blob; lê o { code, message } da API.
export async function readBlobError(error) {
  const data = error && error.response && error.response.data;
  if (!data || typeof Blob === 'undefined' || !(data instanceof Blob)) return null;

  try {
    const parsed = JSON.parse(await data.text());
    return (parsed && parsed.content && parsed.content.error) || null;
  } catch (e) {
    return null;
  }
}
